import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable react/react-in-jsx-scope */
export function Text({ label, type, value, setValue, disabled }) {
  return (
    <div>
      <label
        htmlFor={label}
        className="block text-sm font-medium leading-6 text-white"
      >
        {label}
      </label>
      <div className="relative mt-2">
        <input
          type={type}
          name={label}
          id={label}
          className="peer px-0 bg-transparent block w-full border-0 bg-gray-50 py-1.5 text-white focus:ring-0 sm:text-sm sm:leading-6"
          onChange={(e) => setValue(e.target.value)}
          value={value}
          disabled={disabled}
          maxLength="150"
        />
        <div
          className="absolute inset-x-0 bottom-0 border-t border-gray-300 peer-focus:border-t-2 peer-focus:border-red-700"
          aria-hidden="true"
        />
      </div>
    </div>
  );
}

Text.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  disabled: PropTypes.string
};

// Text.defaultProps = {
//   disabled: '',
// };
